module.exports = __webpack_public_path__ + "static/media/interstitial.679afdf3.jpg";